<template>
	<div class="My_pop _popRight" id="POP-CA" style="display: block;"><!-- POP -->
		<div class="pop_right" :style="{'right':isdetailopen?'640px':'0px'}"><!-- pop_right -->
			<ul class="pop_right_header2">
				<li><h2>咨询与建议</h2></li>
				<li><btn class="pop_right_close2" name="pop-close" @click="closeFloat"></btn></li>
			</ul>
			<div class="pop_right_main"><!-- main -->
				
				<el-tabs v-model="zixunjianyiColum" :stretch="true">
					<el-tab-pane label="需求咨询" name="zixun">
						<div class="MyTabs-pane"><!-- 1需求咨询 -->
						
												<ul class="form_list">
													<li>
														<h4><i class="cei-icon icon-imp"></i>所需资料的详细描述</h4>
														<div class="">
															<textarea class="s_textarea" placeholder="请详细描述您的资料需求，我们将竭力为您服务！" v-model="zixunform.desc" rows="10" maxlength="300" style="resize: none;"></textarea>
															<span class="grey1" style="float: right;margin-right: 20px;">{{zixunform.desc.length}}/300</span>
														</div>
														<!-- <div class="s_tip" >xxxxxxxxx</div> -->
													</li>
													<li>
														<h4><i class="cei-icon icon-imp"></i>邮箱</h4>
														<div class=""><input type="text" class="s_input" placeholder="example@example.com" v-model="zixunform.email" ></div>
														<!-- <div class="s_tip" >xxxxxxxxx</div> -->
													</li>
													<li>
														<h4>联系电话</h4>
														<div class=""><input type="text" class="s_input" placeholder="固话请输入区号-电话号" maxlength="13" v-model="zixunform.phone" ></div>
						<!--								<div class="s_tip" >xxxxxxxxx</div>-->
													</li>
												</ul>
												<div class="pop_right_footer2" style="margin: 0">
													<btn class="s_btn"  @click="addzixun" >提交</btn>
												</div>
												
												
												
												<div class="title8 " v-show="zixuntotalResultCount"><!-- title8 -->
												  <div class="L">需求咨询历史</div>
												</div><!-- /title8 -->
						
						
												<div  class="thematic_list  " v-show="zixuntotalResultCount"><!-- thematic_list -->
													<section v-for="(item,index) in zixunresultDataList">
														<dl>
															<dt>
																<div class="T-date"><d1>{{item.updatetime.substring(8,10)}}</d1><d2>{{item.updatetime.substring(0,7)}}</d2></div>
																<T-vline></T-vline>
															</dt>
															<dd style="display: table;height: 54px;">
																<ul style="display: table-cell;vertical-align: middle;" class="list6"  >
																	<!-- <li>
																		<dl>
																			<dt>咨询文章</dt>
																			<dd>中央政治局会议：加大宏观政策实施力度，稳定经济大盘</dd>
																		</dl>
																	</li> -->
																	<li>
																		<dl>
																			<dt>咨询内容</dt>
																			<dd>
																				<txt>{{JSON.parse(item.content)&&JSON.parse(item.content).desc?JSON.parse(item.content).desc:''}}</txt>
																				<a href="javascript:;" @click="showzixunDetail(item.id)" class="more" name="D_CAdetails-1">【详情】</a>
																			</dd>
																		</dl>
																	</li>
																	
																</ul>
															</dd>
														</dl>
													</section>

													
												</div><!-- /thematic_list -->						
												
												<div class="pop_right_footer2" v-show="zixuntotalResultCount">
													<el-row class="pagediv">
														<el-pagination @current-change="changeZixunPage" :current-page="zixunpageNum"
															:page-size="5" layout="prev, pager, next"
															:total="zixuntotalResultCount">
														</el-pagination>
													</el-row>
												</div>
												
						
						
										</div>
					</el-tab-pane>
					<el-tab-pane label="建议反馈" name="jianyi">
						<div class="MyTabs-pane"><!-- 2建议反馈 -->
										 
										 
												<ul class="form_list">
													<li>
														<h4><i class="cei-icon icon-imp"></i>请选择反馈类型</h4>
														<div class="">
															<ul class="mul-choice-list single" >
																<li @click="fankuiform.type='功能异常'" ><check class="cei-icon" v-bind:class="fankuiform.type=='功能异常'?'s-checked':'s-checkbox'"></check>功能异常</li>
																<li @click="fankuiform.type='产品建议'" ><check class="cei-icon" v-bind:class="fankuiform.type=='产品建议'?'s-checked':'s-checkbox'"></check>产品建议</li>
																<li @click="fankuiform.type='其他'" ><check class="cei-icon" v-bind:class="fankuiform.type=='其他'?'s-checked':'s-checkbox'"></check>其他</li>
															</ul>
														</div>
														<!-- <div class="s_tip" >xxxxxxxxx</div> -->
													</li>
													<li>
														<h4><i class="cei-icon icon-imp"></i>请详细描述您的问题</h4>
														<div style="border: 1px solid #d9d9d9;">
															<div class="">
																<textarea class="s_textarea" placeholder="请详细描述您的问题，我们将竭力为您服务！" rows="10" maxlength="300" style="resize: none;border: none !important;" v-model="fankuiform.desc" ></textarea>
																<span class="grey1" style="float: right;margin-right: 20px;">{{fankuiform.desc.length}}/300</span>
															</div>
															<!-- <div class="s_tip" >xxxxxxxxx</div> -->
															<div class="s_insert_pic" style="margin-top: 16px;border: none !important;">
																<div class="s_insert_pic-L" >
																	<btn class="insertpic" title="插入选择图片" >
																		<pic>
																			<input type="file" id="file" accept="image/*" v-on:change="uploadFile" style="opacity: 0;width: 100%;height: 100%;cursor: pointer;"/>
																		</pic>
																	</btn>
																</div>
																<div class="s_insert_pic-R" >
																	<div v-for="(item,index) in fankuiatts" class="pic"><img v-bind:src="item.image"    alt=""/><i class="cei-icon icon-del" @click="delFile(item.attId)"></i></div>
																	<!-- <div class="pic"><img src="images/hot_img.jpg"    alt=""/><i class="cei-icon icon-del"></i></div>
																	<div class="pic"><img src="images/project_3.jpg" class="inpic"   alt=""/><i class="cei-icon icon-del"></i></div> -->
																</div>
															</div>
														</div>
														<span class="grey1" style="float: right;margin-right: 20px;">单张图片最大可上传大小为1MB</span>
														<!-- <div class="s_tip" >xxxxxxxxx</div> -->
													</li>
													<li>
														<h4>联系方式</h4>
														<div class=""><input type="text" class="s_input" placeholder="联系电话/邮箱地址" v-model="fankuiform.phone" ></div>
						<!--								<div class="s_tip" >xxxxxxxxx</div>-->
													</li>
												</ul>
												<div class="pop_right_footer2" style="margin: 0">
													<btn class="s_btn" @click="addfankui"  >提交</btn>
												</div>
												
												
												
												<div class="title8 " v-show="fankuitotalResultCount"><!-- title8 -->
												  <div class="L">建议反馈历史</div>
												</div><!-- /title8 -->
						
						
												<div  class="thematic_list  " v-show="fankuitotalResultCount"><!-- thematic_list -->
													<section v-for="(item,index) in fankuiresultDataList">
														<dl>
															<dt>
																<div class="T-date"><d1>{{item.updatetime.substring(8,10)}}</d1><d2>{{item.updatetime.substring(0,7)}}</d2></div>
																<T-vline></T-vline>
															</dt>
															<dd>
																<ul  class="list6"  >
																	<li>
																		<dl>
																			<dt>反馈类型</dt>
																			<dd>{{JSON.parse(item.content)&&JSON.parse(item.content).type?JSON.parse(item.content).type:''}}</dd>
																		</dl>
																	</li>
																	<li>
																		<dl>
																			<dt>反馈内容</dt>
																			<dd>
																				<txt>{{JSON.parse(item.content)&&JSON.parse(item.content).desc?JSON.parse(item.content).desc:''}}</txt>
																				<a href="javascript:;" @click="showjianyiDetail(item.id)" class="more" name="D_CAdetails-2">【详情】</a>
																			</dd>
																		</dl>
																	</li>
																	
																</ul>
															</dd>
														</dl>
													</section>
													
													
												</div><!-- /thematic_list -->						
												
												<div class="pop_right_footer2" v-show="fankuitotalResultCount">
													<el-row class="pagediv">
														<el-pagination @current-change="changeFankuiPage" :current-page="fankuipageNum"
															:page-size="5" layout="prev, pager, next"
															:total="fankuitotalResultCount">
														</el-pagination>
													</el-row>
												</div>				 
										 
										</div>
					</el-tab-pane>
				</el-tabs>

			</div><!-- /main -->
			
		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /POP -->
</template>

<script>
	export default {
		data() {
			return{
				loadingMask: false,
				zixunjianyiColum:'zixun',
				zixunform: {
					desc: '',
					email:'',
					phone:''
				},
				zixunpageNum: 1,
				zixunpageSize: 5,
				zixuntotalResultCount: 0,
				zixunresultDataList: [],
				fankuiform: {
					type: '产品建议',
					desc:'',
					phone:''
				},
				fankuiatts:[],
				fankuipageNum: 1,
				fankuipageSize: 5,
				fankuitotalResultCount: 0,
				fankuiresultDataList: [],
			}
		},
		props: [
			'userinfo',
			'isdetailopen',
			'showcolum'
		],
		mounted: function() {
			this.zixunjianyiColum=this.showcolum;
			this.getZixunListfnc();
			this.getFankuiListfnc();
		},
		methods: {
			getZixunListfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/lstUserFeedback',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							feedbacktype:'1',
							iPageNum: this.zixunpageNum,
							iPageSize: this.zixunpageSize,
						},
					})
					.then(function(response) {
						_this.zixunresultDataList = response.data.data.data.tempResult.artLst;
						_this.zixuntotalResultCount = response.data.data.data.tempResult.totalCount;
						_this.$track([
							['pagetype','需求咨询列表']
						]);
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changeZixunPage: function(page) {
				// console.log(page);
				this.zixunpageNum = page;
				this.getZixunListfnc();
			},
			addzixun:function(){
				if(!this.zixunform.desc){
					this.$message({
						message: '请填写描述',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.zixunform.email){
					this.$message({
						message: '请填写邮箱',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.zixunform.email){
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if(!regemail.test(this.zixunform.email)){
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}
				
				if(this.zixunform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					if((!regmobile.test(this.zixunform.phone))&&(!regtel.test(this.zixunform.phone))){
						this.$message({
							message: '请填写正确的联系电话,固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempzixun={
					desc:this.zixunform.desc,
					email:this.zixunform.email,
					phone:this.zixunform.phone
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/AddUserFeedback',
						responseType: 'json',
						params: {
							feedbacktype:1,
							userid: this.userinfo.userAccountID,
							title:'需求咨询'+this.userinfo.userAccountID,
							content: JSON.stringify(tempzixun)
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '需求咨询提交成功',
								type: 'success'
							});
							_this.zixunform.desc='';
							_this.zixunform.email='';
							_this.zixunform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','添加需求咨询']
							]);
						}
						else{
							_this.$message({
								message: '需求咨询提交失败',
								type: 'error'
							});
						}
					})
					.catch(function(error) {
						_this.$message({
							message: '需求咨询提交失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			getFankuiListfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/lstUserFeedback',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							feedbacktype:'2',
							iPageNum: this.fankuipageNum,
							iPageSize: this.fankuipageSize,
						},
					})
					.then(function(response) {
						_this.fankuiresultDataList = response.data.data.data.tempResult.artLst;
						_this.fankuitotalResultCount = response.data.data.data.tempResult.totalCount;
						_this.$track([
							['pagetype','建议反馈列表']
						]);
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changeFankuiPage: function(page) {
				// console.log(page);
				this.fankuipageNum = page;
				this.getFankuiListfnc();
			},
			addfankui:function(){
				if(!this.fankuiform.desc){
					this.$message({
						message: '请填写描述',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.fankuiform.type){
					this.$message({
						message: '请选择类型',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.fankuiform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if((!regmobile.test(this.fankuiform.phone))&&(!regtel.test(this.fankuiform.phone))&&(!regemail.test(this.fankuiform.phone))){
						this.$message({
							message: '请填写正确的联系方式,如邮箱、手机号、固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempfankui={
					type:this.fankuiform.type,
					desc:this.fankuiform.desc,
					phone:this.fankuiform.phone
				}
				var tempAttidArr=[];
				var tempAttnameArr=[];
				for(var i=0;i<this.fankuiatts.length;i++){
					tempAttidArr.push(this.fankuiatts[i].attId);
					tempAttnameArr.push(this.fankuiatts[i].fileName);
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/AddUserFeedback',
						responseType: 'json',
						params: {
							feedbacktype:2,
							userid: this.userinfo.userAccountID,
							title:'建议反馈'+this.userinfo.userAccountID,
							content: JSON.stringify(tempfankui),
							atts:tempAttidArr.length>0?tempAttidArr.join(','):'',
							filenames:tempAttnameArr.length>0?tempAttnameArr.join(','):'',
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '建议反馈提交成功',
								type: 'success'
							});
							_this.fankuiform.desc='';
							// _this.fankuiform.type='';
							_this.fankuiform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','添加建议反馈']
							]);
						}
						else{
							_this.$message({
								message: '建议反馈提交失败',
								type: 'error'
							});
						}
						
					})
					.catch(function(error) {
						_this.$message({
							message: '建议反馈提交失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			uploadFile:function(event){
				if(event.target.files.length>0){
					var upfile=event.target.files[0];
					var formdata=new FormData();
					formdata.append('file',upfile);
					let _this = this;
					this.$http({
							method: 'post',
							url: 'UserInfo/UploadFile',
							data: formdata,
							headers: {
							  'Content-Type': 'multipart/form-data'
							}
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.fankuiatts.push(response.data.data.data);
								_this.$message({
									message: '上传成功',
									type: 'success'
								});
							}
							else{
								_this.$message({
									message: '上传失败:'+response.data.data.msg,
									type: 'error'
								});
							}

						})
						.catch(function(error) {
							_this.$message({
								message: '上传错误:'+response.data.data.msg,
								type: 'error'
							});
							// _this.closeFloat();
							console.log(error);
						});
				}
				
			},
			delFile:function(id){
				for(var i=0;i<this.fankuiatts.length;i++){
					if(this.fankuiatts[i].attId==id){
						this.fankuiatts.splice(i,1);
						break;
					}
				}
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			showzixunDetail: function(id) {
				this.$emit('showzixun',id);
			},
			showjianyiDetail: function(id) {
				this.$emit('showjianyi',id);
			},
		}
	}
</script>

<style>
	.My_pop .el-tabs__header{
		margin-bottom: 20px;
	}
	.My_pop .el-tabs__item {
		margin-bottom: 5px;
		font-size: 16px;
		font-weight: 600;
		color: #424656;
	}
	.My_pop .el-tabs__item:hover {
		color: #bd1a2d;
	}
	.My_pop .el-tabs__item.is-active {
		color: #bd1a2d;
	}
	.My_pop .el-tabs__active-bar{
		background-color: #bd1a2d;
	}
	.My_pop .el-tabs__content{
		overflow: unset;
	}
</style>
